import { render, staticRenderFns } from "./Dashboard_WMDS.vue?vue&type=template&id=71a6a224&"
import script from "./Dashboard_WMDS.vue?vue&type=script&lang=js&"
export * from "./Dashboard_WMDS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports